import { HAS } from 'shared/api/query/constants';
import { goal as goalConfig } from 'shared/api/query/configs.json';
import { reverseEdge } from 'shared/api/query/edges';

export default function usePublishedAtFilter() {
  return {
    publishedAtFilter: {
      [goalConfig.model]: {
        filter: { func: { name: HAS, attr: goalConfig.edges.publishedAt } },
        excludedEdges: [goalConfig.edges.parents, reverseEdge(goalConfig.edges.parents)],
      },
    },
  };
}
